import { render, staticRenderFns } from "./assessmentReport.vue?vue&type=template&id=3f6910db"
import script from "./assessmentReport.vue?vue&type=script&lang=js"
export * from "./assessmentReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports